import Firebase, { db } from '../../config/Firebase'
import { Action } from './types'


export const login = (params) => {
    return async (dispatch) => {
        dispatch({ type: Action.USER_ACTION })
        try {
            const { email, password } = params
            const response = await Firebase.auth().signInWithEmailAndPassword(email.trim(), password)
			db.collection('users').doc(response.user.uid).get()
				.then(function(doc){
                    dispatch({ type: Action.USER_AUTHENTICATED, payload: {session: response.user, data: doc.data()}})
                })
                .catch(function(error) {
                    dispatch({ type: Action.USER_ERROR, payload: error})
                    dispatch(logout)
                })
        } catch (error) {
            dispatch({ type: Action.USER_ERROR, payload: error})
        }
    }
}

export const signup = (params) => {
    return async (dispatch) => {
        dispatch({ type: Action.USER_ACTION })
        try {
            const { email, password, name } = params
            const response = await Firebase.auth().createUserWithEmailAndPassword(email.trim(), password)
            if (response.user.uid) {
                
                const user = {
                    uid: response.user.uid,
                    email: email,
                    name: name
                }
                db.collection('users').doc(response.user.uid).set(user)
					.then( function() {
                        dispatch({ type: Action.USER_AUTHENTICATED, payload: {session: response.user, data: user} })
                    })
					.catch( function(error) {
                        response.user.delete()
                        dispatch({ type: Action.USER_ERROR, payload: error})
					})
            }
        } catch (error) {
            dispatch({ type: Action.USER_ERROR, payload: error})
        }
    }
}

export const logout = () => {
    return async (dispatch) => {
        Firebase.auth().signOut()
        .then (function(){
            console.log("se hizo log out")
        })
        .catch (function() {
            console.log("error while sign out")
        })
        
    }
}

export const getUser = () => {
    return async (dispatch, getState) => {
        const { session } = getState().user
        try {
            db.collection('users').doc(session.uid).get()
				.then(function(doc){
                    dispatch({ type: Action.USER_AUTHENTICATED, payload: { session, data: doc.data() }})
                })
                .catch(function(error) {
                    dispatch({ type: Action.USER_ERROR, payload: error})
                    dispatch(logout)
                })
        } catch (error) {
            dispatch({ type: Action.USER_ERROR, payload: error})
        }
    }
}

export const setPushNotificationsToken = (token) => {
    return (dispatch, getState) => {
        const { uid } = getState().user.session
        if (uid){
            const databaseRef = db.collection('users').doc(uid)
            databaseRef.update({
                expoToken: token
            }).then(() => {
                console.log("El registro se ingreso")
            })
                .catch((error) => {
                    console.log("error: ", error)
                })
        }
    }
}

export const forgotPassword = (params) => {
    return (dispatch) => {
        dispatch({ type: Action.USER_ACTION })
        try {
            const { email } = params
            Firebase.auth().sendPasswordResetEmail(email)
            .then(() => {
                dispatch({ type: Action.FORGOT_PASSWORD_SENT, payload: {message: 'Email sent'} })
                return true
            })
            .catch (error => {
                dispatch({ type: Action.USER_ERROR, payload: error})
                return false
            })
        } catch (error) {
            dispatch({ type: Action.USER_ERROR, payload: error})
            return false
        }
    }
}

export const resetError = () => {
    return (dispatch) => {
        dispatch({ type: Action.USER_ERROR_RESET })
    }
}

export const uploadProfileImage = (uri, progressCallback) => {
    return async (dispatch, getStore) => {
        dispatch({ type: Action.PROFILE_IMAGE_UPLOADING })
        const response = await fetch(uri)
        const blob = await response.blob()
        const userId = getStore().user.data.uid
        const requestId = getStore().request.rid
        var metadata = {
            contentType: 'image/jpeg',
        };

        //let name = new Date().getTime() + "-media.jpg"
        let name = "profileImage.jpg"
        const ref = Firebase
            .storage()
            .ref()
            .child('images/' + userId + '/profile/' + '/' + name)

        const task = ref.put(blob, metadata);

        return new Promise((resolve, reject) => {
            task.on(
                'state_changed',
                (snapshot) => {
                    progressCallback && progressCallback(snapshot.bytesTransferred / snapshot.totalBytes)

                    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                    dispatch({ type: Action.PROFILE_IMAGE_UPLOAD_PROGRESS, payload: { progress } })
                },
                (error) => reject(error), /* this is where you would put an error callback! */
                () => {
                    task.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                        //dispatch({ type: Action.PROFILE_IMAGE_UPLOADED, payload: downloadURL })
                        const databaseRef = db.collection('users').doc(userId)
                        databaseRef.update({
                            profileImage: downloadURL
                        }).then(() => {
                            console.log("El registro se ingreso")
                            dispatch({ type: Action.PROFILE_IMAGE_UPLOADED, payload: downloadURL })
                        })
                            .catch((error) => {
                                console.log("error: ", error)
                            })
                    })
                }
            )
        })
    }
}

export const retrieveMyRequests = (uid) => {
    return async (dispatch, getStore) => {
        dispatch({ type: Action.USER_ACTION })
        try{
            const limit = 15
            //query to get all requests ordered by date of creation
            //const { uid } = getStore().user.session
            let initialQuery = await db.collection('requests')
                .where("uid", "==", uid)
                .orderBy('date_created', 'desc')
                .limit(limit)

            let documentSnapshots = await initialQuery.get()
            //console.log("documents: ", documentSnapshots.docs)

            //create a reference for users
            //let users = await db.collection('users')
            //create array of requests data
            let documentData = documentSnapshots.docs.map( document => {
                
                const request = {
                    data: document.data(),
                    id: document.id
                }
                //document.data() 
                return request
            })

            //let's save the lastVIsible to paginate new results
            //let lastVisible = documentData[documentData.length - 1]
            let lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1]
            const lastPage = documentSnapshots.docs.length < limit ? true : false
            //we save the list on our store
            dispatch({ type: Action.USER_INITIAL_REQUESTS, payload: { list: documentData, lastVisible, lastPage } })

        } catch(error) {
            console.log("get requests error: ", error)
            dispatch({ type: Action.USER_ERROR, payload: error})
        }
    }
}

export const retrieveNextRequests = (uid) => {
    return async (dispatch, getStore) => {
        //console.log("retrieve more data")
        dispatch({ type: Action.USER_ACTION })
        try{
            let { lastVisible } = getStore().user
            //const { uid } = getStore().user.session
            const limit = 10
            let additionalQuery = await db.collection('requests')
                .where("uid", "==", uid)
                .orderBy('date_created', 'desc')
                .startAfter(lastVisible)
                .limit(limit)

            let documentSnapshots = await additionalQuery.get()

            //create array of requests data
            let documentData = documentSnapshots.docs.map( document => {
                
                const request = {
                    data: document.data(),
                    rid: document.id
                }
                //document.data() 
                return request
            })

            //let's save the lastVIsible to paginate new results
            //lastVisible = documentData[documentData.length - 1]
            lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1]
            const lastPage = documentSnapshots.docs.length < limit ? true : false
            //we save the list on our store
            dispatch({ type: Action.USER_MORE_REQUESTS, payload: { list: documentData, lastVisible, lastPage } })

        } catch(error) {
            console.log("get requests error: ", error)
            dispatch({ type: Action.USER_ERROR, payload: error})
        }
    }
}

export const resetUserRequests = () => {
    return (dispatch) => {
        dispatch({type: Action.USER_RESET_REQUESTS})
    }
}